import styled, { css } from 'styled-components';

export const Button = styled.button`
  display: flex;
  white-space: nowrap;
  scroll-snap-align: start;
  justify-content: center;
  align-items: center;

  ${({ theme }) => css`
    color: ${theme.colors.almostBlack};
    background-color: ${theme.colors.transparent};
    font-size: ${theme.fontSizes.p3};
    border: 1px solid ${theme.colors.defaultAdd5};
    gap: ${theme.spacing(1)};
    padding: ${theme.spacing(1, 2)};
  `}

  &:hover {
    color: ${({ theme }) => theme.colors.primary};

    > * {
      color: initial;
    }
  }
`;
